<template>
	<div>
		<buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" ref="SetBtn"></buttonlist>

		<!-- <el-tabs :tab-position="'top'" type="" style="margin-top: 5px">
			<el-tab-pane :label="$t('getapi[945]')" name="0"> -->
				<!-- <el-table
					:data="dataSet"
					v-loading="loading"
					:highlight-current-row="true"
					show-overflow-tooltip="true"
					border
					stripe
					size="mini"
					:height="tableHeight"
					header-row-class-name="headerclass"
					@selection-change="handleSelectionChange"
					style="width: 100%; margin-top:0px"
				>
					<el-table-column type="selection" v-if="true"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="mp_flag" :label="$t('getapi[2363]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[137]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Qty_on_hand" :label="$t('getapi[3101]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="MeasureUnit" :label="$t('getapi[888]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="batch_no" :label="$t('getapi[1763]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="sequence_no" :label="$t('getapi[1764]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="cargo_position" :label="$t('getapi[1957]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="cargo_Type" :label="$t('getapi[867]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="cargo_Group" :label="$t('getapi[1108]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Assist_Qty_on_hand" :label="$t('getapi[2389]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_ASSIST_UNIT" :label="$t('getapi[130]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Part_status" :label="$t('getapi[552]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="commodity_type_NAME" :label="$t('getapi[120]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_model" :label="$t('getapi[124]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_spec" :label="$t('getapi[125]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_stuff" :label="$t('getapi[126]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="receive_time" :label="$t('getapi[2100]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="ISSUE_TIME" :label="$t('getapi[2179]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="cost_unit_price" :label="$t('getapi[2248]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="assign_qty" :label="$t('getapi[2184]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Expiry_Date" :label="$t('getapi[225]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="CusPart_ID" :label="$t('getapi[2390]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="CusPart_Name" :label="$t('getapi[2391]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="frozenman" :label="$t('getapi[2392]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="frozentype" :label="$t('getapi[2393]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="items" :label="$t('getapi[2394]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Consumption_Date" :label="$t('getapi[1512]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Ice_out_date" :label="$t('getapi[2397]')"></el-table-column>
				</el-table> -->
			<!-- </el-tab-pane> -->
			<ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
			<li style="width: 100%; margin-top:0px">
				<wTable id="xpane-0" :data="dataSet" :loading="loading" :header="tableHeader"
						queryData="SalLogisticsAndSummaryViewInfo"
						:filter_thousandth="['init_qty','init_amount','in_amount','out_qty','out_amount','final_qty','final_amount','in_qty']"
						@handleSelectionChange="handleSelectionChange" :option="tableOption"  @contextmenu.prevent.native="openMenu($event)"
						ref="singleTable"></wTable>
			</li>
		</ul>
			<el-row class="page">
				<el-col :span="18">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="pageSize"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
				</el-col>
			</el-row>
		<!-- </el-tabs> -->
		<serce :isVisible="isVisible" queryData="SalLogisticsAndSummaryViewInfo" ref="ser" @getser="serclick"></serce>
		<!-- 改变表格顺序 -->
		<ctable :isVisible="false" :title="$t('getapi[1031]')" queryData="SalLogisticsAndSummaryViewInfo" tabNo="0" ref="ctab" @getctab="sortclick"></ctable>
	
		<!-- 详情页面 -->
		<!-- <purordermanage :isVisible="isVisible" ref="order" @getdetail="getdetail"></purordermanage> -->
		<!-- 选择时间 -->
		<el-dialog v-dialogDrag :title="$t('getapi[6433]')" :visible.sync="dialogVisible" width="30%">
			<div class="bbl">
			<span>{{$t('getapi[6434]')}}</span>
			<el-date-picker v-model="copyparam.startMonth" popper-class="select-option" type="month" value-format="yyyy-MM" :placeholder="$t('getapi[6428]')" size="mini"></el-date-picker>
			</div>
			<div class="bbl">
			<span>{{$t('getapi[6435]')}}</span>
			<el-date-picker v-model="copyparam.copyMonth" popper-class="select-option" type="month" value-format="yyyy-MM" :placeholder="$t('getapi[6428]')" size="mini"></el-date-picker>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button  @click="dialogVisible = false">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="copyconfirm">{{$t('getapi[1146]')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'expresstotal',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3,
                maxHeight: this.$windowSize.tableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			dialogVisible: false, //时间选择弹框
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('expresstotal'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			tableHeader: [],
			dataDetail: {
				Head: {},
				Lists: []
			}, // 编辑页面数据详情
			PlanTypeArray: [], // 计划类型数组
			isEdit: true, // 是否新增操作
			selectIDList: [],
			selectObj: {
				part_code: '',
				part_version: '',
				exclusively_id: 0,
				shelflife: ''
			},
			copyparam:{
				startMonth:'',
				copyMonth:'',
			},
			btn: {
				//拷贝
				copy: false,
				//删除
				delete: false,
			},
            scrollTop:0,
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
		that.colsort();
		let lastmonth = new Date().getMonth() ;
		let thismonth = new Date().getMonth() + 1;
		let myyear = new Date().getFullYear();
		if (lastmonth < 10) {
		lastmonth = '0' + lastmonth;
		}
		if (thismonth < 10) {
		thismonth = '0' + thismonth;
		}
		that.copyparam.startMonth = myyear+"-"+lastmonth;
		that.copyparam.copyMonth = myyear+"-"+thismonth;

	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
		colsort(){
			let that = this;
			that.$loadviewfields.Fileds('SalLogisticsAndSummaryViewInfo',0,PFileds=>{
			that.tableHeader=PFileds;		
		});	
		},
		sortclick(val){
			if(val==1){
				this.colsort();
			}
		},
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1031]"),this.$t("getapi[14]"));
        },
		//type 1 一览权限 、2 编辑界面权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			let limits=1;
			that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
			//只读权
			if (that.$limits.ReadOnlyRightsView('plv2', 93, 1, that.total)) {
				if (that.total > 0) {
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
				} else {
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
				}
			}
			//操作权限-查询级别
			limits = that.$limits.OperationAuthorityView('plv2', 93, 1, that.total);
			// limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			switch (limits) {
				case -1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				default:
					break;
			}
			if(limits==-1||limits==1)that.closeAllRightButton();
            else that.btnauthority();
		},
		btnauthority() {
			let that = this;
			that.btn.copy = false;
			that.btn.delete = false;
			if (that.$limits.authority('plv4', 62, 1) == 1) {
				that.btn.copy = true;
			} 
			if (that.$limits.authority('plv4', 93, 1) == 1) {
				that.btn.delete = true;
			} 
		},
		closeAllRightButton(){
			let that =this;
			that.btn.copy = false;
			that.btn.delete = false;
		},
		changeperiod() {
			let that = this;
			that.$http.urlpost('/Inv/Manager/InvInfoUpdateShelflife', that.selectObj, function(res) {
				if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
					that.getView();
				}
				that.dialogVisible = false;
			});
		},
		showdialog() {
			let that = this;
			if (that.selectObj.exclusively_id == 0) {
				that.$message.warning(that.$t('getapi[8623]'));//'请选择一项！'
				return;
			}
			that.dialogVisible = true;
		},
		handleSelectionChange(val) {
		let that = this;
		that.selectIDList=val;
		},
		
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('expresstotal',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.pageIndex=1;
			that.$refs.ser.clearInput(that.isVisible, 'SalLogisticsAndSummaryViewInfo');
		},
		// 修改表格顺序
		opentable(){
			this.$refs.ctab.clearInputs(true);
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				Param: datac
			};
			that.$http.urlpost('/Sal/Tru/SalLogisticsAndSummaryViewDataList', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
				}
				that.authority();
			});
		},
		// 根据ID获取详情数据
		editInfo(row) {
			let that = this;
			that.isShowEdit = true;
			that.isEdit = true;
			let parm = {
				Code: row.PO_Code,
				List: []
			};
			this.$refs.order.clearInput(this.isShowEdit, parm);
		},
		// 新增
		add() {
			let that = this;
			let datetime = Common.methods.getDatetime()
			that.isEdit = false;
			that.isShowEdit = true;
			that.dataDetail = {
				Head: {},
				Lists: []
			};
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		//按月拷贝成本
		copy(){
			let that = this;
			that.dialogVisible = true;
			
		},
		copyconfirm(){
			//  
			let that = this;
			that.btn.copy = false
			let parm = {
			"newmonth": that.copyparam.copyMonth.split("-")[1],
			"newyear": that.copyparam.copyMonth.split("-")[0],
			"oldmonth": that.copyparam.startMonth.split("-")[1],
			"oldyear": that.copyparam.startMonth.split("-")[0],
			}

			that.$http.urlpost('/Inv/PartCost/InvPartStdCostCopyCost', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
				}
				that.btn.copy = true;
				that.dialogVisible = false;
			});


		},
		deleteline(){
			let that = this;
			that.btn.delete = false;
			let token = JSON.parse(that.userData).token;
			let geturl = Common.Url + 'Inv/PartCost/InvPartStdCostDeleteCost?costID='+that.selectIDList[0].Exclusively_Id+'&token=' + token;
			that.$http.gets(geturl, '', function (res) {
			if (res.data.Success == 1) {
				that.$message.success(res.data.Msg);
				that.getView();
			}else{
				that.$message.warning(res.data.Msg);
			}
			that.btn.delete = true;
			});

		},
		// 导出
		exps() {
			/*let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndexs,
				Ids: '',
				Param: datac
			};
			that.$http.urlpost('/Sal/Tru/SalLogisticsAndSummaryViewExportToExecl', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
				that.loading = false;
			});*/
            let that = this;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                query_sign: "SalLogisticsAndSummaryViewInfo",
                fromname: that.$t('getapi[1031]'),
                SelectIndex: 0,
                MultyVer: that.$processdata.getLanguage(),
                Param: datac
            };
            that.$processdata.commonExport(parm)
		},
		// 保存
		save() {
			let that = this;
			let parm = that.dataDetail;
			that.$http.urlpost('/Pur/Requisition/SaveData', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
				}
			});
		},
		//
		editInfo1() {},
		editInfo2() {},
		editInfo3() {}
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}

.bbl {
	margin: 0px auto 10px;
	white-space: pre;
	span {
		margin-left: 10px;
		min-width: 70px;
		text-align: left;
		line-height: 20px;
		display: inline-block;
		margin-right: 0px;
	}
}
</style>
